const _ = require('lodash');

export default {
  methods: {
    /**
     * Translate the given key.
     */
    trans(key: string, replace: Record<string, string>): string {
      // @ts-ignore
      let translation = window.i18n[key] ? window.i18n[key] : key;

      _.forEach(replace, (value: string, key: string) => {
        translation = translation.replace(':' + key, value);
      });

      return translation
    },
  },
};
